import React from 'react';
import {Result} from 'antd';

function NotAuthorityView() {
    return (
        <Result
            status="403"
            title="403"
            subTitle="没有权限访问"
            style={{marginTop: 200, backgroundColor: 'transparent'}}
        />
    );
}

export default NotAuthorityView;
